module.exports = __webpack_public_path__ + "static/media/timelapse.f2721cbe.mp4";